import { ref, reactive } from 'vue'
export const statisticObject = reactive({
  scriptId: null,
  scriptVer: null,
  beginDateTime: null,
  clientId: null,
  sessionId: null,
  activity: []
})
export let sequence = ref(1)
window.statisticObject = statisticObject
window.saveStatistic = () => {
  statisticObject.activity.forEach((el) => {
    el.createdAt = (new Date(el.createdAt)).toISOString()
    el.dur = el.dur > 0 && el.dur < 1000 ? 1 : Math.round(el.dur / 1000)
    if (el.dur === 0) {
      delete el.elementId;
      delete el.elementValue;
    }
    if (typeof el.elementValue === 'object' && el.elementValue !== null) {
      el.elementValue = JSON.stringify(el.elementValue)
    }
    if (el.activityType !== 'step') {
      delete el.stepId
    }
  });
  statisticObject.activity[statisticObject.activity.length - 1].dur = 
		Math.round((Date.now() - new Date(statisticObject.activity[statisticObject.activity.length - 1].createdAt).getTime()) / 1000);
		statisticObject.activity.push({
			sequence: sequence.value,
			activityType: 'save',
			createdAt: (new Date(Date.now())).toISOString(),
			dur: 1,
		});
  sequence.value++
  console.log(statisticObject.activity)
  const lastStepIndex = statisticObject.activity.findLastIndex((el) => el.activityType === 'step');
  const lastStep = JSON.parse(JSON.stringify(statisticObject.activity[lastStepIndex]))
  lastStep.sequence = sequence.value;
  lastStep.createdAt = Date.now()
	lastStep.dur = 0
  sequence.value++
  statisticObject.activity = [lastStep]
  console.log(statisticObject.activity)
}

export const addLastDuration = () => {
  if (statisticObject.activity.length) {
    statisticObject.activity[statisticObject.activity.length - 1].dur = Date.now() - statisticObject.activity[statisticObject.activity.length - 1].createdAt;
  }
}

export const autoSaver = ref()

export const modalOpened = ref(false)

export const useStatistic = () => {}